// 네이버 로그인/회원가입 공용: 인가(authorize) 페이지로 이동
// state 는 CSRF 검증용으로 sessionStorage 에 보관 → /sso/callback 에서 대조

// 네이버 클라이언트 ID (공개값 — 브라우저 authorize URL 에 그대로 노출되므로 하드코딩 안전).
// 배포 환경변수(REACT_APP_NAVER_CLIENT_ID)가 있으면 우선 사용.
const NAVER_CLIENT_ID = process.env.REACT_APP_NAVER_CLIENT_ID || 'oRJVWMm1TEk_1UmoQZyr';

// redirect URI: 환경변수가 있으면 사용, 없으면 "현재 접속 도메인 + /sso/callback" 으로 자동 생성.
// → 로컬/Vercel/Cloudflare 어디서 열어도 그 도메인으로 자동 매칭(도메인 불일치 방지).
const getRedirectUri = () =>
  process.env.REACT_APP_NAVER_REDIRECT_URI
  || `${window.location.origin}/sso/callback`;

export const redirectToNaverAuthorize = () => {
  const clientId = NAVER_CLIENT_ID;
  const redirectUri = getRedirectUri();
  if (!clientId || !redirectUri) {
    throw new Error('네이버 로그인 설정이 없습니다. 관리자에게 문의하세요.');
  }

  const state = window.crypto?.randomUUID?.()
    || `${Date.now()}_${Math.random().toString(36).slice(2)}`;
  sessionStorage.setItem('naver_oauth_state', state);

  const authorizeUrl =
    'https://nid.naver.com/oauth2.0/authorize?response_type=code'
    + `&client_id=${encodeURIComponent(clientId)}`
    + `&redirect_uri=${encodeURIComponent(redirectUri)}`
    + `&state=${encodeURIComponent(state)}`;

  window.location.href = authorizeUrl;
};
